import classNames from 'classnames'
import { forwardRef } from 'react'
import TextInputWrapper from '../TextInputWrapper'
import styles from './TextInput.module.css'
import { TextInputProps } from './types'

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      label,
      name,
      description,
      error,
      warning,
      id,
      required,
      className,
      children,
      invisibleLabel,
      inputSize = 'default',
      errorDisplay = 'all',
      'aria-disabled': ariaDisabled_,
      disabled,
      disabled_,
      readOnly,
      fullWidth,
      inputContainerClassName,
      wrapperClassName,
      ...props
    }: TextInputProps,
    ref
  ) => {
    const descriptionIds = []
    if (children) descriptionIds.push(`${name}-suffix`)
    if (error) descriptionIds.push(`${name}-error`)
    if (warning) descriptionIds.push(`${name}-warning`)
    if (description) descriptionIds.push(`${name}-description`)
    const inputDisabled = disabled_ || disabled
    const ariaDisabled = ariaDisabled_ || inputDisabled

    return (
      <TextInputWrapper
        label={label}
        name={name}
        description={description}
        error={error}
        warning={warning}
        id={id || name}
        required={required}
        errorDisplay={errorDisplay}
        invisibleLabel={invisibleLabel}
        fullWidth={fullWidth}
        className={wrapperClassName}
      >
        <div className={classNames(styles.inputContainer, inputContainerClassName)}>
          <input
            {...props}
            ref={ref}
            id={id || name}
            name={name}
            aria-describedby={descriptionIds.length ? descriptionIds.join(' ') : undefined}
            aria-invalid={!!error}
            aria-required={required}
            aria-disabled={ariaDisabled}
            aria-readonly={readOnly}
            disabled={disabled_}
            readOnly={readOnly}
            className={classNames(styles.input, className, {
              [styles['input--error']!]: !!error,
              [styles.hasSuffix!]: !!children,
              [styles.inputLarge!]: inputSize === 'large',
              ['fullWidth']: fullWidth && fullWidth !== 'mobile-only',
              ['fullWidthOnMobile']: fullWidth && fullWidth === 'mobile-only',
            })}
          />
          {children}
        </div>
      </TextInputWrapper>
    )
  }
)

TextInput.displayName = 'TextInput'

export default TextInput
